import { Grid, GridRow } from '@bp/ui-components';
import { AssignmentPreviewStudent } from 'components/Assignments/components/AssignmentPreview/AssignmentPreviewStudent';
import { useAssignments } from 'components/Assignments/hooks/useAssignments';
import { AssignmentsStudentTable } from 'components/Assignments/tables/AssignmentsStudentTable';
import { useRequireParams } from 'hooks/useRequireParams';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BpCard } from '../../../../components/BpCard/BpCard';

export const CourseAssignmentsStudentContent = () => {
  const { t } = useTranslation();
  const { courseUuid } = useRequireParams(['courseUuid']);
  const navigate = useNavigate();

  const { getAssignmentPath } = useAssignments({ courseUuid });

  function handleNavigate(assignmentUuid: string) {
    navigate(getAssignmentPath(assignmentUuid));
  }

  return (
    <Grid>
      <GridRow>
        <AssignmentPreviewStudent onNavigate={(uuid) => handleNavigate(uuid)} />
      </GridRow>
      <GridRow>
        <BpCard header={{ headline: t('assignments.finishedAssignments') }} noPadding noMargin={false}>
          <AssignmentsStudentTable onNavigate={(uuid) => handleNavigate(uuid)} />
        </BpCard>
      </GridRow>
    </Grid>
  );
};
